<app-pep-syndicated-header
  [basePath]="syndicatedHeaderConfig.path"
  [version]="syndicatedHeaderConfig.version"
  [siteId]="syndicatedHeaderConfig.siteId"
  [environment]="syndicatedHeaderConfig.environment"
  [hideNavigation]="1"
  class="header">
</app-pep-syndicated-header>
<router-outlet></router-outlet>
